import React from 'react'
import DetailRow from './common/DetailRow'
import Disclaimer from './Disclaimer'

class Fixed extends React.Component {
  render() {
    const {
      loanAmountLabel,
      repaymentWithFrequency,
      interestTypeLabel,
      fixedInterestPeriodLabel,
      rateLabel,
      repaymentType,
      repaymentTypeLabel,
      overallLoanTermLabel,
      futureRepayment,
    } = this.props

    return(
      <div>
        <DetailRow title='Loan amount' >
          <div>{ loanAmountLabel }</div>
        </DetailRow>

        <DetailRow title='Repayment of' >
          <div>{ repaymentWithFrequency }</div>
        </DetailRow>

        <DetailRow title='Rate' >
          <div>Fixed rate of {rateLabel} p.a.</div>
        </DetailRow>

        <DetailRow title='Repayment type' >
          <div>{ repaymentTypeLabel }</div>
        </DetailRow>

        <DetailRow title='Fixed loan term' >
          <div>{ fixedInterestPeriodLabel }</div>
        </DetailRow>

        <DetailRow title='Overall loan term' >
          <div>{ overallLoanTermLabel }</div>
        </DetailRow>
        {
          (repaymentType == 'interest_only') && (
            <div>
              <br />
              <Disclaimer
                futureRepayment={ futureRepayment }
              />
            </div>

          )
        }
      </div>
    )
  }
}

export default Fixed;
